export const REWARDS_BY_ID = 'REWARDS_BY_ID';
export const NO_GETTER = 'NO_GETTER';

// Destinations module
export const DESTINATIONS_BY_UUID = 'DESTINATIONS_BY_UUID';
